import type { TenantConfig } from '../../schema.ts';

const config: TenantConfig = {
  id: 'nokto',
  appTitle: 'Nokto EMS',
  appleMobileWebAppTitle: 'Nokto EMS',
  description: 'Nokto EMS',
  htmlLang: 'en',
  themeColor: '#FD5200',
  manifest: {
    name: 'Nokto EMS',
    short_name: 'Nokto EMS',
    description: 'Nokto EMS App',
    theme_color: '#FD5200',
    background_color: '#f9fafb',
    display: 'standalone',
    orientation: 'portrait',
    id: '/',
    scope: '/',
    start_url: '/',
    screenshots: [
      {
        src: 'icons/screenshot.png',
        sizes: '640x320',
        type: 'image/png',
        form_factor: 'wide',
        label: 'Nokto',
      },
      {
        src: 'icons/screenshot-mobile.png',
        sizes: '377x830',
        type: 'image/png',
        form_factor: 'narrow',
        label: 'Nokto',
      },
    ],
    icons: [
      { src: 'icons/16x16.png', sizes: '16x16', type: 'image/png' },
      { src: 'icons/32x32.png', sizes: '32x32', type: 'image/png' },
      { src: 'icons/72x72.png', sizes: '72x72', type: 'image/png' },
      { src: 'icons/96x96.png', sizes: '96x96', type: 'image/png' },
      { src: 'icons/120x120.png', sizes: '120x120', type: 'image/png' },
      { src: 'icons/128x128.png', sizes: '128x128', type: 'image/png' },
      { src: 'icons/144x144.png', sizes: '144x144', type: 'image/png' },
      { src: 'icons/152x152.png', sizes: '152x152', type: 'image/png' },
      { src: 'icons/180x180.png', sizes: '180x180', type: 'image/png' },
      { src: 'icons/192x192.png', sizes: '192x192', type: 'image/png' },
      { src: 'icons/384x384.png', sizes: '384x384', type: 'image/png' },
      { src: 'icons/512x512.png', sizes: '512x512', type: 'image/png' },
      { src: 'icons/512x512.png', sizes: '512x512', type: 'image/png', purpose: 'maskable' },
    ],
  },
  support: {
    email: 'support@nokto.eu',
  },
  font: {
    family: 'PT Sans',
    preload: [
      {
        href: '/fonts/pt-sans/PTSans-Regular.woff2',
        type: 'font/woff2',
        crossOrigin: 'anonymous',
      },
      {
        href: '/fonts/pt-sans/PTSans-Bold.woff2',
        type: 'font/woff2',
        crossOrigin: 'anonymous',
      },
    ],
  },
};

export default config;
